<template>
  <v-dialog v-model="showDialog" persistent max-width="1000px">
    <v-card>
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="formConjuntoProducto" :v-model="true" lazy-validation>
            <v-flex xs12>
              <v-combobox
                v-model="conjuntoProducto.producto"
                :items="productos"
                item-text="descripcionProducto"
                :loading="loadingProductos"
                item-value="productoId"
                label="Producto"
                placeholder="Producto"
                single-line
                :rules="[
                  () =>
                    !!conjuntoProducto.productoId || 'El campo es requerido',
                ]"
                @change="setProducto"
                required
              ></v-combobox>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                label="Cantidad de productos en el conjunto / servicio"
                v-model="conjuntoProducto.cantidad"
                :rules="[
                  (v) => !!conjuntoProducto.cantidad || 'El campo es requerido',
                ]"
                type="number"
              ></v-text-field>
            </v-flex>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveConjuntoProducto"
          >Guardar</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >Producto agregado al conjunto</v-alert
      >
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
  </v-dialog>
</template>

<script>
import productoService from "@/services/productoService";
import conjuntoProductoService from "@/services/conjuntoProductoService";

export default {
  props: {
    conjuntoProducto: {
      type: Object,
    },
    conjunto: {
      type: Object,
    },
  },
  data() {
    return {
      showDialog: false,
      loadingProductos: false,
      productos: [],
      registroNuevo: true,
      readOnly: false,
    };
  },
  mounted() {
    this.getProductos();
  },
  watch: {
    conjunto: function (newConjunto) {
      conjuntoProducto.conjuntoId = newConjunto.conjuntoId;
    },
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    setUpdate(esActualizacion) {
      if (esActualizacion) {
        this.readOnly = true;
        this.registroNuevo = false;
      } else {
        this.readOnly = false;
        this.registroNuevo = true;
      }
    },
    setProducto(producto) {
      this.conjuntoProducto.productoId = producto.productoId;
    },
    getProductos() {
      let self = this;
      self.loadingProductos = true;
      productoService
        .getAllForDrop()
        .then((result) => {
          self.productos = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingProductos = false;
        });
    },
    saveConjuntoProducto() {
      let self = this;

      if (self.$refs.formConjuntoProducto.validate()) {
        self.operationStart();

        if (self.registroNuevo) {
          self.addProductoConjunto();
        } else {
          self.updateProductoConjunto();
        }
      }
    },
    addProductoConjunto() {
      let self = this;

      conjuntoProductoService
        .add(self.conjuntoProducto)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onConjuntoProductoAdded", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateProductoConjunto() {
      let self = this;

      conjuntoProductoService
        .update(self.conjuntoProducto)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onConjuntoProductoUpdated", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.conjuntoProducto.productoId = 0;
      self.conjuntoProducto.cantidad = 0;
      self.conjuntoProducto.producto = {
        productoId: 0,
        descripcionProducto: "",
      };
      self.$refs.formConjuntoProducto.resetValidation();
    },
  },
};
</script>
